import React from "react";
import { Mail, Phone, MapPin, FileDown, Send } from "lucide-react";
import { useLanguage } from "@/i18n";

const portfolioPdf = `${process.env.PUBLIC_URL}/assets/AbdulrahmanAlarifi_portfolio.pdf`;
const portfolioPassword = "AbdulPHD";

const ITEMS = [
  { icon: Mail, label: "a.alarifi@a-narch.com", href: "mailto:a.alarifi@a-narch.com", testId: "contact-email" },
  { icon: Phone, label: "+44 7460 389 560", href: "tel:+447460389560", testId: "contact-phone" },
  { icon: MapPin, label: "Birmingham · UK", href: null, testId: "contact-location" },
];

export const ContactContent = ({ onOpenForm }) => {
  const { t } = useLanguage();

  return (
  <div>
    <ul className="space-y-2.5">
      {ITEMS.map((it, i) => {
        const Icon = it.icon;
        const inner = (
          <span className="flex items-center gap-3 text-sm text-ink hover:text-accentRed transition">
            <Icon size={14} className="text-ink-faint shrink-0" />
            <span className="font-mono text-[11px] tracking-[0.06em] break-all">{it.label}</span>
          </span>
        );
        return (
          <li key={i} data-testid={it.testId}>
            {it.href ? (
              <a href={it.href}>{inner}</a>
            ) : (
              inner
            )}
          </li>
        );
      })}
    </ul>

    <div className="mt-5 pt-4 border-t border-dashed border-[var(--paper-edge)] grid grid-cols-2 gap-2">
      <button
        data-testid="btn-portfolio-pdf"
        type="button"
        onClick={() => {
          const entered = window.prompt(t("portfolioPrompt"));
          if (entered === portfolioPassword) {
            window.open(portfolioPdf, "_blank", "noopener,noreferrer");
          } else if (entered !== null) {
            window.alert(t("portfolioWrong"));
          }
        }}
        className="group flex items-center justify-center gap-2 px-3 py-2.5 border border-ink text-ink hover:bg-ink hover:text-paper transition font-mono text-[10px] uppercase tracking-[0.2em]"
      >
        <FileDown size={13} /> {t("portfolio")}
      </button>
      <button
        data-testid="btn-contact-form"
        type="button"
        onClick={onOpenForm}
        className="group flex items-center justify-center gap-2 px-3 py-2.5 bg-accentRed text-paper hover:bg-ink transition font-mono text-[10px] uppercase tracking-[0.2em]"
      >
        <Send size={13} /> {t("getInTouch")}
      </button>
    </div>
  </div>
  );
};
